(function () {
  'use strict';

  const WISHLIST_KEY = 'limenda_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount_with_comma_separator}} €');
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function fetchProduct(handle) {
    return fetch(`/products/${encodeURIComponent(handle)}.js`)
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn) return;
    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'Wird hinzugefügt…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw res;
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Hinzugefügt';
        if (window.LimendaTutus?.showCartToast) {
          window.LimendaTutus.showCartToast();
        }
        if (window.LimendaTutus?.updateHeaderCartCount) {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window.LimendaTutus.updateHeaderCartCount(cart.item_count);
            })
            .catch(function () {});
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Fehler';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1800);
      });
  }

  function renderCard(product, root) {
    const variant = product.variants.find(function (v) {
      return v.available;
    }) || product.variants[0];
    const image = product.featured_image || (product.images && product.images[0]);
    const card = document.createElement('article');
    card.className = 'l-wishlist-card';
    card.dataset.handle = product.handle;

    card.innerHTML = `
      <a href="${product.url}" class="l-wishlist-card__media">
        <img class="l-wishlist-card__img" src="${image || ''}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy">
      </a>
      <div class="l-wishlist-card__body">
        <a href="${product.url}" class="l-wishlist-card__title">${product.title}</a>
        <p class="l-wishlist-card__price">${formatMoney(variant.price)}</p>
        <div class="l-wishlist-card__actions">
          <button type="button" class="l-wishlist-card__atc" data-variant-id="${variant.id}" ${variant.available ? '' : 'disabled'}>
            ${variant.available ? 'In den Warenkorb' : 'Ausverkauft'}
          </button>
          <button type="button" class="l-wishlist-card__remove" data-remove-handle="${product.handle}" aria-label="Aus Favoriten entfernen">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
        </div>
      </div>
    `;

    card.querySelector('[data-variant-id]')?.addEventListener('click', function (e) {
      addToCart(parseInt(e.currentTarget.dataset.variantId, 10), e.currentTarget);
    });

    card.querySelector('[data-remove-handle]')?.addEventListener('click', function (e) {
      const handle = e.currentTarget.dataset.removeHandle;
      const list = getWishlist().filter(function (h) {
        return h !== handle;
      });
      setWishlist(list);
      card.remove();
      if (!root.querySelector('.l-wishlist-card')) {
        renderEmpty(root);
      }
    });

    return card;
  }

  function renderEmpty(root) {
    const grid = root.querySelector('[data-l-wishlist-grid]');
    const empty = root.querySelector('[data-l-wishlist-empty]');
    const loading = root.querySelector('[data-l-wishlist-loading]');
    if (loading) loading.hidden = true;
    if (grid) {
      grid.innerHTML = '';
      grid.hidden = true;
    }
    if (empty) empty.hidden = false;
  }

  function renderWishlist(root) {
    const grid = root.querySelector('[data-l-wishlist-grid]');
    const empty = root.querySelector('[data-l-wishlist-empty]');
    const loading = root.querySelector('[data-l-wishlist-loading]');
    const handles = getWishlist();

    if (!grid) return;

    if (!handles.length) {
      renderEmpty(root);
      return;
    }

    if (loading) loading.hidden = false;
    if (empty) empty.hidden = true;
    grid.hidden = true;
    grid.innerHTML = '';

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      const valid = products.filter(Boolean);
      if (loading) loading.hidden = true;

      if (!valid.length) {
        setWishlist([]);
        renderEmpty(root);
        return;
      }

      valid.forEach(function (product) {
        grid.appendChild(renderCard(product, root));
      });
      grid.hidden = false;
      if (empty) empty.hidden = true;
    });
  }

  function initWishlist(scope) {
    const root = (scope || document).querySelector('[data-l-wishlist]');
    if (!root || root.dataset.lWishlistInit) return;
    root.dataset.lWishlistInit = '1';
    renderWishlist(root);
  }

  function toggleWishlistHandle(handle, buttons) {
    if (!handle) return false;
    const list = getWishlist();
    const index = list.indexOf(handle);
    const active = index === -1 ? (list.push(handle), true) : (list.splice(index, 1), false);
    setWishlist(list);
    (buttons || []).forEach(function (btn) {
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    return active;
  }

  function syncWishlistButtons(scope) {
    scope = scope || document;
    const list = getWishlist();
    scope.querySelectorAll('[data-l-wishlist-btn][data-product-handle]').forEach(function (btn) {
      const handle = btn.dataset.productHandle;
      const active = list.includes(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function initWishlistButtons(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-l-wishlist-btn][data-product-handle]').forEach(function (btn) {
      if (btn.dataset.lWishlistBtnInit) return;
      btn.dataset.lWishlistBtnInit = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.productHandle;
        const cardButtons = scope.querySelectorAll(`[data-l-wishlist-btn][data-product-handle="${handle}"]`);
        toggleWishlistHandle(handle, cardButtons);
      });
    });
    syncWishlistButtons(scope);
  }

  window.LimendaTutus = window.LimendaTutus || {};
  window.LimendaTutus.toggleWishlist = toggleWishlistHandle;
  window.LimendaTutus.syncWishlistButtons = syncWishlistButtons;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWishlist();
      initWishlistButtons();
    });
  } else {
    initWishlist();
    initWishlistButtons();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-l-wishlist]');
    if (root) {
      delete root.dataset.lWishlistInit;
      initWishlist(e.target);
    }
    initWishlistButtons(e.target);
  });
})();
